import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'presenceStatus'
})
export class PresenceStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
